// Textos da interface, agrupados por feature. Cada tela traz os seus na Fase 5.
// Variáveis no formato {{nome}} (o mesmo do react-i18next).
// Erros e sucessos ficam em errors.pt-BR.ts e success.pt-BR.ts.
export const ptBR = {
  common: {
    back: "Voltar",
    cancel: "Cancelar",
    retry: "Tentar novamente",
    loading: "Carregando…",
    goHome: "Ir para o início",
    errorCode: "Código: {{code}}",
    step: "Passo {{step}} de 2 · {{label}}",
  },
  nav: {
    label: "Menu principal",
    newOrder: "Novo Pedido",
    savedOrders: "Pedidos Salvos",
    appeals: "Recursos",
    support: "Suporte",
    admin: "Admin",
    settings: "Configurações",
  },
  upgrade: {
    title: "Limite atingido",
    cta: "Fazer upgrade de plano",
    close: "Fechar",
  },
  autosave: {
    saving: "Salvando…",
    saved: "Salvo às {{time}}",
    error: "Não foi salvo",
  },
  // Vínculos do médico (empresas de OPME, hospitais, reservas): Configurações e envio por e-mail.
  // Escolha das empresas de OPME que entram na guia e no resumo do pedido.
  companySelect: {
    titleAsk: "Empresas vinculadas",
    titleLink: "Vincular uma empresa",
    titleSelect: "Selecione as empresas",
    ask: "Deseja inserir os dados de alguma empresa vinculada ao seu perfil na guia de OPME e no resumo deste pedido?",
    no: "Não, obrigado",
    yes: "Sim, escolher",
    linkFirst: "Você ainda não tem nenhuma empresa vinculada ao seu perfil. Vincule uma abaixo para incluir os dados dela na guia de OPME e no resumo deste pedido.",
    linkMore: "Vincule mais uma empresa abaixo para incluir os dados dela na guia de OPME e no resumo deste pedido.",
    linkSubmit: "Vincular e continuar",
    selectHint: "Selecione até {{max}} empresas para incluir no PDF.",
    linkAnother: "+ Vincular outra",
    limitReached: "Limite de {{max}} empresas atingido",
    count: "{{count}}/{{max}}",
    back: "Voltar",
    confirm: "Confirmar",
  },
  validation: {
    cpfIncomplete: "CPF incompleto. Informe os 11 dígitos.",
    cpfInvalid: "CPF inválido. Confira os números.",
    crmFormat: "Informe o número e a UF do CRM, por exemplo 123456/SP.",
    crmUf: "UF do CRM inválida. Use a sigla do estado, por exemplo SP.",
    birthFuture: "A data de nascimento não pode ser futura.",
    birthTooOld: "Confira o ano: a data é anterior a 1900.",
    dateInPast: "Escolha uma data e hora no futuro.",
    cardExpired: "Carteirinha vencida. Confira a validade.",
    emailInvalid: "Confira o e-mail: falta o @ ou o domínio.",
    phoneMissing: "Informe o DDD e o número.",
    phoneInvalidDdd: "DDD inválido. Verifique os dois primeiros dígitos.",
    phoneIncomplete: "Número incompleto. Informe o DDD e 8 ou 9 dígitos.",
  },
  links: {
    searching: "Buscando...",
    name: "Nome",
    linkOnly: "Apenas vincular",
    saveAndLink: "Salvar e vincular",
    save: "Salvar",
    saving: "Salvando...",
    unlink: "Desvincular",
    unlinkLabel: "Desvincular {{name}}",
    unlinkConfirm: "Tem certeza que deseja desvincular {{name}}?",
    editLabel: "Editar {{name}}",
    add: "Adicionar",
    company: {
      loading: "Carregando empresas...",
      empty: "Nenhuma empresa de OPME vinculada ainda.",
      unlinkTitle: "Desvincular empresa",
      namePlaceholder: "Digite o nome da empresa",
      phonePlaceholder: "Telefone (opcional)",
      emailPlaceholder: "E-mail (opcional)",
      emailRequiredPlaceholder: "E-mail *",
      cnpjPlaceholder: "CNPJ (opcional)",
      submit: "Vincular empresa",
      nameRequired: "Informe o nome da empresa.",
      alreadyLinked: "Esta empresa já está vinculada.",
      emailRequired: "Informe o e-mail da empresa para poder enviar documentos a ela.",
      reviewTitle: "Confira os dados da empresa",
      reviewEmailMissing: "Esta empresa está cadastrada, mas ainda não tem um e-mail. Informe um e-mail para poder enviar documentos a ela.",
      reviewMissing: "Esta empresa já está cadastrada. Confira os dados abaixo e, se quiser, complete alguma informação que ainda está faltando.",
      reviewComplete: "Esta empresa já está cadastrada com todos os dados preenchidos.",
      linkComplete: "Vincular esta empresa",
      phone: "Telefone",
      email: "E-mail",
      cnpj: "CNPJ",
      fieldRequired: "(obrigatório para envio por email)",
      fieldMissing: "(não informado)",
      fieldPlaceholder: "Informe o {{field}}",
    },
    hospital: {
      loading: "Carregando hospitais...",
      empty: "Nenhum hospital vinculado ainda.",
      unlinkTitle: "Desvincular hospital",
      namePlaceholder: "Digite o nome do hospital",
      emailPlaceholder: "E-mail do hospital",
      submit: "Vincular hospital",
      required: "Informe o nome e o e-mail do hospital.",
      alreadyLinked: "Este hospital já está vinculado.",
      reviewTitle: "Confira os dados do hospital",
      reviewText: "Este hospital já está cadastrado. Confira os dados abaixo e corrija algo, se necessário.",
      nameField: "Nome do hospital",
      email: "E-mail",
    },
    reserva: {
      loading: "Carregando reservas...",
      empty: "Nenhuma reserva vinculada ainda.",
      unlinkTitle: "Desvincular reserva",
      namePlaceholder: "Digite o nome da reserva",
      submit: "Vincular reserva",
      linking: "Vinculando reserva...",
      nameRequired: "Informe o nome da reserva.",
      alreadyLinked: "Esta reserva já está vinculada.",
      editTitle: "Editar reserva",
      editText: "Esta reserva pode estar vinculada a outros médicos — a alteração vale para todos.",
      nameField: "Nome da reserva",
    },
  },
  settings: {
    title: "Configurações",
    shortcuts: "Atalhos",
    shortcut: { account: "Conta", profile: "Perfil", files: "Documentos", links: "Vínculos", email: "E-mail" },
    account: { title: "Conta & Plano", subtitle: "Seu plano atual e assinatura", subtitleClinic: "Plano da clínica" },
    plan: {
      current: "Plano atual",
      cancelScheduled: "Cancelamento agendado",
      clinicAccess: "Acesso da clínica",
      trial: "Período de teste",
      noSpecialty: "Especialidade não informada",
      endsOn: "Sua assinatura termina em {{date}}. Até lá você mantém o plano; depois volta ao {{free}}.",
      endsAtPeriodEnd: "Sua assinatura termina no fim do período. Até lá você mantém o plano; depois volta ao {{free}}.",
      reactivate: "Reativar assinatura",
      reactivated: "Assinatura reativada. Nada muda na sua cobrança.",
      trialUntil: "Você está no período de teste até {{date}}. A primeira cobrança é nessa data; se cancelar antes, nada é cobrado.",
      changeTo: "Seu plano muda para {{plan}}.",
      changeToOn: "Seu plano muda para {{plan}} em {{date}}.",
      keepCurrent: "Manter plano atual",
      changeCancelled: "Troca cancelada. Você continua no plano atual.",
      status: "Status",
      accessUntil: "Acesso até",
      firstCharge: "Primeira cobrança",
      nextCharge: "Próxima cobrança",
      card: "Cartão",
      noCard: "Nenhum cartão padrão — cadastre em Cartão e faturas",
      invoices: "Faturas",
      noInvoices: "Nenhuma fatura ainda",
      boletoPending: "Boleto gerado, aguardando pagamento",
      overdue: "Vencida em {{date}}",
      pay: "Pagar",
      view: "Ver",
      changePlan: "Mudar plano",
      cancel: "Cancelar assinatura",
      cancelNow: "Cancelar agora",
      cancelled: "Assinatura cancelada.",
      cancelledAtEnd: "Cancelamento agendado para o fim do período.",
    },
    portal: {
      talkToLetsDoc: "Falar com a LetsDoc",
      choosePlan: "Escolher plano",
      opening: "Abrindo...",
      cardAndInvoices: "Cartão e faturas",
      updateCard: "Atualizar cartão",
    },
    cancel: {
      retentionTitle: "Tem certeza que quer sair do {{plan}}?",
      retentionBody: "Ao cancelar, você deixa de ter acesso a:",
      cheaper: "Prefere pagar menos?",
      seePlans: "Ver planos",
      keep: "Manter meu plano",
      continue: "Continuar cancelamento",
      nowTitle: "Encerrar agora?",
      nowBody: "Seu cancelamento já está agendado. Você pode antecipar para agora.",
      howTitle: "Como você quer cancelar?",
      howBody: "Escolha quando o cancelamento vale.",
      when: "Quando cancelar",
      atEnd: "No fim do período",
      recommended: "Recomendado",
      atEndTrialOn: "Você usa o teste até {{date}} e nada é cobrado. Pode reativar quando quiser.",
      atEndTrial: "Você usa o teste até o fim e nada é cobrado. Pode reativar quando quiser.",
      atEndOn: "Você continua com acesso até {{date}}. Pode reativar quando quiser.",
      atEndPaid: "Você continua com acesso até o fim do período já pago. Pode reativar quando quiser.",
      now: "Cancelar agora",
      nowTrial: "O teste termina agora e você volta ao plano Básico. Nada é cobrado.",
      nowPaid: "Você volta ao plano Básico imediatamente. O valor do período já pago não é reembolsado.",
      back: "Voltar",
      confirm: "Confirmar cancelamento",
    },
    clinic: {
      title: "Minha clínica",
      subtitle: "Vagas do plano e médicos com acesso",
      loading: "Carregando clínica…",
      loadError: "Não foi possível carregar os dados da clínica.",
      basicPlan: "Plano Básico",
      basicPlanBody: "{{count}} médico(s) na clínica, sem vagas contratadas. Para liberar vagas e convidar médicos,",
      talkToLetsDoc: "fale com a LetsDoc",
      planFallback: "Plano",
      contracted: "Médicos contratados",
      added: "Adicionados (sem cobrança)",
      contractValue: "Valor do contrato",
      nextInvoice: "Próxima fatura",
      flatValue: "Valor fechado da clínica — não multiplica pelas vagas",
      extras: " · {{count}} extra(s) não entram na fatura",
      seats: "{{used}} de {{total}} vaga(s) ocupada(s)",
      seatsFree: "{{count}} livre(s) para convidar",
      noSeats: "Todas as vagas já estão ocupadas ou reservadas em convites pendentes. Peça ao admin da LetsDoc para liberar mais médicos.",
      howMany: "Quantos médicos",
      invite: "Convidar médicos",
      linkCreated: "Link criado!",
      activeLinks: "Links de convite ativos",
      linkUsage: "{{left}} de {{max}} vaga(s) restante(s) neste link · válido até {{date}}",
      copy: "Copiar",
      copied: "Copiado!",
      remove: "Remover",
      removeTitle: "Remover {{name}} da clínica?",
      removeBody: "{{name}} sai da clínica e passa para o plano Básico, com uma conta independente. A vaga fica livre.",
      removed: "Médico removido da clínica.",
    },
    profile: {
      title: "Perfil do Médico",
      subtitle: "Nome, CRM e especialidade nas prescrições",
      name: "Nome",
      namePlaceholder: "Nome do Médico",
      crm: "CRM",
      crmHint: "Número e UF.",
      specialty: "Especialidade",
      specialtyPlaceholder: "Selecione uma especialidade",
      save: "Salvar alterações",
      saving: "Atualizando...",
      saved: "Dados atualizados com sucesso!",
      nameTooShort: "Insira o nome completo.",
    },
    files: {
      title: "Arquivos",
      subtitle: "Receituário PDF e carimbo para prescrições",
      prescription: "Receituário",
      prescriptionHint: "PDF do seu receituário",
      prescriptionUpload: "Enviar PDF",
      prescriptionError: "Envie um arquivo PDF.",
      prescriptionSuccess: "Receituário salvo.",
      stamp: "Carimbo",
      stampHint: "Imagem PNG ou JPG do carimbo",
      stampUpload: "Enviar imagem",
      stampError: "Envie uma imagem PNG ou JPG.",
      stampSuccess: "Carimbo salvo.",
      none: "Nenhum arquivo enviado",
      replace: "Trocar",
      sending: "Enviando...",
      loading: "Buscando...",
      loadError: "Não conseguimos ver o arquivo atual",
    },
    emailConnection: {
      checking: "Verificando conexão...",
      loadError: "Não conseguimos verificar a conta de e-mail conectada.",
      connected: "Conectado via Google",
      connectedBadge: "Conectado",
      disconnect: "Desconectar",
      disconnectTitle: "Desconectar conta de email",
      disconnectConfirm: "Tem certeza que deseja desconectar {{email}}? Você não poderá enviar documentos por email até reconectar.",
      intro: "Conecte sua conta Google para enviar PDFs de pedidos diretamente para hospitais por email.",
      permissionBefore: "Na tela de consentimento do Google, não esqueça de marcar a permissão",
      permission: "\"Enviar e-mail no seu nome\"",
      permissionAfter: "— sem ela, o envio de email não vai funcionar.",
      connect: "Conectar conta Google",
      redirecting: "Redirecionando...",
    },
    secretaries: {
      loading: "Carregando e-mails...",
      title: "Adicionar E-mails",
      subtitle: "Adicione até 2 e-mails para dar acesso",
      label: "E-mails adicionados",
      placeholder: "Digite um e-mail",
      limitReached: "Limite atingido",
      add: "Adicionar",
      addLink: "Adicionar e-mail",
      invalid: "Insira um e-mail válido.",
      duplicate: "Este e-mail já foi adicionado.",
      max: "Máximo de {{max}} e-mails permitidos.",
      remove: "Remover {{email}}",
      removeTitle: "Remover e-mail",
      removeConfirm: "Tem certeza que deseja remover {{email}}?",
      removeAction: "Remover",
      countOne: "{{count}}/{{max}} e-mail adicionado",
      countOther: "{{count}}/{{max}} e-mails adicionados",
    },
    kits: {
      title: "Pacotes Personalizados",
      subtitle: "Crie e gerencie seus kits de prescrição",
      loading: "Carregando pacotes…",
      empty: "Nenhum pacote personalizado ainda.",
      procedures: "Procedimentos · {{items}}",
      opme: "OPME · {{items}}",
      add: "Novo pacote",
    },
    companies: { title: "Empresas", subtitle: "Empresas às quais você está vinculado" },
    hospitals: { title: "Hospitais", subtitle: "Hospitais aos quais você está vinculado" },
    bookings: { title: "Reservas", subtitle: "Reservas às quais você está vinculado" },
    emailAccount: {
      title: "Conta de email",
      subtitle: "Conecte sua conta Google para enviar documentos por email",
      permissionDeniedTitle: "Falta a permissão de envio",
      permissionDeniedBody: "Clique em \"Conectar conta Google\" de novo e marque \"Enviar e-mail no seu nome\" na tela do Google.",
    },
  },
  savedOrders: {
    title: "Pedidos Salvos",
    orderCount: { zero: "Nenhum pedido", one: "1 pedido", other: "{{count}} pedidos" },
    searchPatient: "Busque por um paciente",
    searchOrder: "Busque por um pedido",
    empty: "Nenhum pedido salvo",
    emptyHint: "Os pedidos gerados aparecem aqui automaticamente.",
    createOrder: "Criar pedido",
    noPatient: "Nenhum paciente encontrado com esse nome.",
    noPatientHint: "Verifique a grafia ou busque pelo sobrenome.",
    noOrder: "Nenhum pedido encontrado.",
    loadError: "Não conseguimos carregar seus pedidos",
    loadErrorHint: "Seus pedidos continuam salvos. Tente de novo em instantes.",
    noProcedure: "Sem procedimento",
    status: {
      completo: "Pedido completo",
      aguardando: "Aguardando dados do paciente",
      incompleto: "Pedido incompleto",
    },
    summary: {
      title: "Resumo",
      date: "Data",
      hospital: "Hospital",
      procedures: "Procedimentos",
      opme: "OPME",
      cid: "CID",
      codes: { zero: "Nenhum", one: "1 código", other: "{{count}} códigos" },
      items: { zero: "Nenhum", one: "1 item", other: "{{count}} itens" },
      download: "Baixar resumo",
    },
    guide: {
      title: "Guia",
      hint: "Guia de internação e guia de OPME deste pedido.",
      admission: "Internação",
      opme: "OPME",
      choiceTitle: "Incluir dados do paciente?",
      choiceHint: "A guia pode sair só com o pedido ou também com nome, convênio e carteirinha do paciente.",
      withoutPatient: "Só a guia",
      withPatient: "Com dados do paciente",
    },
    share: {
      email: "Enviar por e-mail",
      whatsapp: "Enviar pelo WhatsApp",
    },
    edit: {
      title: "Editar pedido",
      hint: "Reabre este pedido no Novo Pedido com os dados preenchidos.",
      action: "Ir para Novo Pedido",
    },
    appeal: {
      title: "Recurso",
      done: "Recurso gerado",
      none: "Nenhum recurso gerado para este pedido.",
      download: "Baixar PDF do recurso",
      create: "Gerar recurso",
    },
    noRequest: {
      title: "Pedido de cirurgia não gerado",
      message: "Este pedido salvo ainda não possui um pedido de cirurgia gerado. Continue gerando o pedido para realizar o download.",
      action: "Continuar gerando pedido",
      close: "Fechar",
    },
    patient: {
      title: "Dados do paciente",
      name: "Nome completo",
      birth: "Data de nascimento",
      sex: "Sexo",
      select: "Selecione",
      female: "Feminino",
      male: "Masculino",
      cpf: "CPF",
      plan: "Convênio",
      cardNumber: "Nº da carteirinha",
      cardValidity: "Validade da carteirinha",
      download: "Baixar PDF",
    },
  },
  patientData: {
    title: "Dados do paciente",
    home: "Início",
    ocr: {
      title: "Fotografar carteirinha",
      description: "Preenchemos convênio, número e validade automaticamente",
    },
    identification: "Identificação",
    name: "Nome",
    birth: "Data de nascimento",
    cpf: "CPF",
    sex: "Sexo",
    female: "Feminino",
    male: "Masculino",
    healthPlan: "Convênio",
    planProduct: "Produto do convênio",
    planProductPlaceholder: "Ex.: Enfermaria, Apartamento",
    cardNumber: "Nº da carteirinha",
    cardNumberPlaceholder: "Conforme a carteirinha",
    cardValidity: "Validade da carteirinha",
    summary: "Resumo",
    opme: "OPME",
    share: "Compartilhar",
    email: "Enviar guias por e-mail",
    emailDescription: "Com os dados do paciente",
    whatsapp: "Enviar pelo WhatsApp",
    whatsappDescription: "Paciente ou secretária",
    downloadGuide: "Baixar guia de internação",
  },
  newOrder: {
    title: "Novo Pedido de Cirurgia",
    logout: "Logout",
    logoutLabel: "Sair da conta",
    logoutTitle: "Sair da conta?",
    logoutBody: "Seus pedidos permanecem salvos. Para acessar novamente, entre com o mesmo e-mail.",
    logoutConfirm: "Sair",
    noSpecialty: "Especialidade não informada",
    recordTitle: "Grave a consulta para preencher automaticamente",
    recordBody: "Ao gravar a conversa com o paciente, o sistema analisa a consulta e preenche os campos abaixo.",
    recordingTitle: "Gravando consulta · toque para encerrar",
    transcribingTitle: "Analisando consulta…",
    transcribingBody: "Extraindo da conversa as informações para preencher os campos.",
    recordedTitle: "Consulta gravada",
    recordedBody: "Os campos abaixo foram preenchidos. Revise antes de analisar.",
    recordedToast: "Consulta transcrita",
    manual: "ou preencha manualmente",
    patientName: "Digite o nome do paciente",
    patientNamePlaceholder: "Ex.: Maria Aparecida Souza",
    history: "Descreva o caso cirúrgico",
    historyPlaceholder: "Ex.: lombalgia há 2 anos com irradiação para perna esquerda, sem melhora após 6 meses de fisioterapia e analgésicos.",
    historyHint: "Histórico clínico e sintomas que justificam o procedimento.",
    laudo: "Resultados de exames complementares",
    laudoNumber: "({{n}})",
    laudoPlaceholder: "Ex.: RM de coluna lombar: hérnia discal L4-L5 com compressão radicular.",
    addLaudo: "Adicionar laudo",
    removeLaudo: "Remover laudo {{n}}",
    maxLaudos: "Máximo de {{n}} laudos por pedido.",
    dictate: "Ditar {{field}}",
    stopDictation: "Parar ditado",
    analyze: "Analisar",
    missing: "Preencha {{fields}} para analisar.",
    missingName: "o nome do paciente",
    missingHistory: "a descrição do caso",
    missingLaudo: "o resultado de exame",
    and: " e ",
    analyzing1: "Lendo o histórico do paciente",
    analyzing2: "Analisando os laudos",
    analyzing3: "Buscando códigos de cirurgia",
    cancelledTitle: "Análise cancelada",
    cancelledBody: "Os dados preenchidos foram mantidos.",
    noProcedures: "Nenhum procedimento encontrado",
    noProceduresBody: "Revise o caso e os laudos e analise de novo.",
  },
  surgicalIndication: {
    title: "Indicação Cirúrgica",
    hospital: "Digite o nome do hospital",
    hospitalPlaceholder: "Ex.: Hospital Santa Clara",
    hospitalHint: "Sugerimos os hospitais cadastrados em Configurações.",
    date: "Digite a data e a hora desejada",
    surgery: "Cirurgia",
    elective: "Eletiva",
    emergency: "Emergência",
    confirm: "Confirmar e gerar pedido",
    missing: "Preencha hospital, data e tipo de cirurgia",
  },
  catalog: {
    add: "Adicionar",
    added: "Adicionado",
    addItem: "Adicionar {{name}}",
  },
  kits: {
    search: "Buscar pacote",
    searchPlaceholder: "Busque o pacote por nome",
    noMatch: "Nenhum pacote encontrado com esse nome.",
    recommended: "Recomendado pela Inteligência Artificial",
    recommend: "Recomendar pacote com IA",
    recommendedName: "A IA recomendou: {{name}}",
    noRecommendation: "Nenhum pacote combina com este caso",
    noRecommendationBody: "A IA não encontrou um pacote com os procedimentos deste caso. Escolha um manualmente ou crie um novo.",
  },
  kitBuilder: {
    title: "Novo pacote personalizado",
    name: "Nome do pacote",
    namePlaceholder: "Ex.: Artrodese cervical 1 nível",
    nameMissing: "Dê um nome ao pacote.",
    savedAs: "Será salvo como “{{name}}”",
    kind: "Itens do pacote",
    procedures: "Procedimentos",
    opme: "OPME",
    search: "Filtrar itens",
    searchProc: "Filtre por código ou procedimento",
    searchOpme: "Filtre por nome do OPME",
    notFound: "Nenhum item encontrado com esse termo.",
    items: { one: "1 item", other: "{{count}} itens" },
    units: { one: "1 unidade", other: "{{count}} unidades" },
    selected: "Selecionados: {{items}}, {{units}}.",
    noneSelected: "Nenhum item selecionado. Toque em Adicionar e ajuste a quantidade.",
    create: "Criar pacote",
    limit: "Você atingiu o limite máximo de pacotes para seu plano. Faça upgrade para criar mais.",
  },
  procedures: {
    title: "Procedimentos",
    mode: "Forma de escolha",
    kits: "Pacotes",
    free: "Escolha Livre",
    kitsHint: "Escolha um pacote pronto com os códigos do procedimento.",
    freeHint: "Revise os códigos identificados e ajuste as quantidades.",
    identified: "Identificamos esses códigos:",
    emptyTitle: "Nenhum código selecionado.",
    emptyHint: "Adicione pela lista abaixo.",
    addOthers: "Adicionar outros códigos:",
    search: "Filtrar procedimentos",
    searchPlaceholder: "Filtre por código ou procedimento",
    notFound: "Nenhum procedimento encontrado. Tente buscar pelo código TUSS.",
    confirm: "Confirmar",
    confirmCount: { one: "Confirmar 1 procedimento", other: "Confirmar {{count}} procedimentos" },
    freeMissing: "Adicione ao menos um procedimento para continuar.",
    chooseKit: "Escolha o pacote com códigos dos procedimentos:",
    kitType: "Tipo de pacote",
    standard: "Padronizados",
    custom: "Personalizados",
    standardTitle: "Pacote Padronizado:",
    standardText: "criados pela plataforma Letsdoc.",
    customTitle: "Pacote Personalizado:",
    customText: "criados com base na escolha do médico.",
    aiText: "Se quiser, a IA recomenda um pacote pelo histórico clínico e o laudo.",
    noStandard: "Nenhum pacote padronizado cadastrado",
    noStandardHint: "Entre em contato com o suporte para novos cadastros.",
    noCustom: "Nenhum pacote personalizado cadastrado",
    noCustomHint: "Cadastre um novo pacote no botão abaixo.",
    confirmKit: "Confirmar pacote",
    kitMissing: "Selecione um pacote para continuar.",
    newKit: "Adicione seu pacote personalizado",
  },
  opme: {
    title: "OPME",
    kitsHint: "Escolha um pacote de materiais.",
    freeHint: "Pesquise e selecione os materiais um a um.",
    selected: "OPMEs selecionados:",
    emptyTitle: "Nenhum OPME selecionado.",
    emptyHint: "Escolha na lista abaixo ou adicione o seu.",
    pick: "Selecione os códigos OPME:",
    search: "Filtrar OPME",
    searchPlaceholder: "Filtre por nome do OPME",
    notFound: "Nenhum OPME encontrado com \"{{query}}\".",
    addAsOpme: "Adicionar \"{{name}}\" como OPME",
    addOwn: "Adicionar seu OPME",
    itemName: "Nome do item",
    itemNameMissing: "Informe o nome do item.",
    add: "Adicionar",
    cancel: "Cancelar",
    confirmCount: { one: "Confirmar 1 item", other: "Confirmar {{count}} itens" },
    freeMissing: "Selecione ao menos um OPME para continuar.",
    chooseKit: "Escolha o pacote com códigos de OPME's:",
    notes: "Observações adicionais dos OPMEs",
    notesPlaceholder: "Ex.: solicito 3 marcas para cotação.",
    notesHint: "Opcional. Aparece no fim da guia de OPME.",
  },
  download: {
    title: "Pedido gerado e salvo",
    newOrder: "Novo Pedido",
    approve: "Aprovar Pedido",
    preparing: "Estamos preparando seu pedido estruturado",
    failed: "Não foi possível gerar o pedido. Nada foi aprovado ainda.",
    editHint: "Toque em um campo para editar. As alterações são salvas automaticamente.",
    reviewStatus: "Revise e aprove",
    approvedStatus: "Aprovado",
    showMore: "Ver mais",
    showLess: "Ver menos",
    approvedTitle: "Pedido aprovado.",
    approvedBody: "Agora você pode baixar e compartilhar os documentos.",
    readOnly: "Gerado automaticamente",
    patient: "Paciente",
    patientName: "Nome do Paciente",
    patientDescription: "Descrição do Paciente",
    order: "Pedido",
    procedures: "Procedimentos",
    cids: "CID's",
    opmeSummary: "Justificativa técnica OPME",
    schedule: "Agendamento",
    hospital: "Hospital",
    desiredDate: "Data e hora desejada",
    issueDate: "Data de Emissão",
    summary: "Resumo",
    otherGuides: "Outras guias",
    otherGuidesTitle: "Baixar outras guias",
    admissionGuide: "Guia de internação",
    opmeGuide: "OPME",
    patientData: "Inserir dados do paciente",
    share: "Compartilhar",
    email: "Enviar guias por e-mail",
    emailDescription: "Hospitais e empresas vinculados",
    whatsapp: "Enviar pelo WhatsApp",
    whatsappDescription: "Abre a conversa com mensagem pronta",
  },
  guides: {
    summaryTitle: "Descrição do paciente (resumida)",
    summaryStep: "Descrição resumida",
    summaryHint: "A guia de internação tem espaço limitado. Usamos uma versão resumida da descrição do paciente; a versão completa continua no pedido.",
    summaryLabel: "Descrição resumida",
    summaryReview: "Revise e edite se necessário.",
    summaryTooLong: "Reduza o texto para no máximo {{max}} caracteres.",
    generating: "Gerando a descrição resumida…",
    generateError: "Não foi possível gerar a descrição resumida agora.",
    regenerate: "Gerar de novo",
    continue: "Continuar",
    admissionTitle: "Guia de internação",
    opmeTitle: "Guia de OPME",
    planStep: "Plano de saúde",
    planHint: "Escolha o plano de saúde do paciente",
    plan: "Plano de saúde",
    searchPlan: "Buscar plano",
    noPlan: "Nenhum plano encontrado. Confira a grafia ou fale com o suporte para incluir o modelo de guia.",
    download: "Baixar guia",
    downloadPlan: "Baixar guia {{plan}}",
  },
  references: {
    panel: {
      count: { one: "1 referência incluída", other: "{{count}} referências incluídas" },
      hint: "No último resumo baixado",
      view: "Ver ou alterar",
      redownload: "Baixar novamente",
    },
    review: {
      promptTitle: "Incluir referências técnicas?",
      promptBody: "Referências bibliográficas científicas podem ser inseridas ao final do PDF de resumo para embasar tecnicamente a solicitação.",
      yes: "Sim, buscar referências",
      no: "Não, apenas o resumo",
      loading: [
        "Buscando referências técnicas",
        "Consultando bases científicas",
        "Analisando procedimentos e materiais",
        "Organizando as referências encontradas",
      ],
      loadingHint: "Isso pode levar alguns segundos.",
      errorTitle: "Não foi possível buscar as referências.",
      skipDownload: "Baixar sem referências",
      title: "Referências técnicas",
      selected: { one: "1 referência selecionada", other: "{{count}} referências selecionadas" },
      intro: "Revise as referências sugeridas. Remova as que não forem pertinentes e abra o link de cada referência incluída para conferir antes de confirmar.",
      procedures: "Procedimentos",
      opme: "Materiais / OPME",
      reload: "Recarregar",
      reloading: "Buscando",
      itemSelected: "{{selected}}/{{total}} selecionadas",
      openLink: "Abrir link",
      checked: "Conferido",
      include: "Incluir",
      included: "Incluída",
      noLink: "sem link",
      abnt: "ABNT:",
      atLeastOne: "Ao menos uma referência",
      linksChecked: "Links conferidos {{opened}}/{{total}}",
      declaration: "Declaro que revisei as referências bibliográficas listadas e assumo a responsabilidade técnica pelo seu uso no resumo.",
      confirm: "Confirmar e baixar",
      emptyTitle: "Nenhuma referência encontrada",
      emptyBody: "Não foram encontradas referências para os itens selecionados.",
      continueWithout: "Continuar sem referências",
    },
  },
  sharing: {
    editableTemplate: "Modelo editável",
    messageLabel: "Mensagem",
    messagePreview: "Prévia da mensagem",
    continue: "Continuar",
    whatsApp: {
      title: "Enviar pelo WhatsApp",
      composeStep: "Número e mensagem",
      reviewStep: "Revisão",
      phoneLabel: "Número do WhatsApp",
      phonePlaceholder: "(11) 91234-5678",
      phoneHint: "Celular ou fixo, com DDD.",
      attachNotice: "O WhatsApp não permite anexar arquivos automaticamente. Baixe os PDFs e anexe-os na conversa.",
      reviewIntro: "Confira os dados. Ao continuar, o WhatsApp abre com a conversa e a mensagem já preenchidas.",
      recipient: "Destinatário",
      link: "Link da conversa",
      copy: "Copiar",
      copied: "Copiado",
      copyFailed: "Não foi possível copiar. Selecione o link e copie manualmente.",
      reviewNotice: "Lembre-se de anexar os PDFs na conversa antes de enviar a mensagem.",
      open: "Abrir WhatsApp",
      greeting: "Olá!",
      aboutWithDoctorAndPatient: "Aqui é o(a) Dr(a). {{doctor}}, sobre o pedido cirúrgico do paciente {{patient}}.",
      aboutWithPatient: "Segue mensagem sobre o pedido cirúrgico do paciente {{patient}}.",
      aboutWithDoctor: "Aqui é o(a) Dr(a). {{doctor}}, sobre o pedido cirúrgico.",
      about: "Segue mensagem sobre o pedido cirúrgico.",
      pdfsFollow: "Vou enviar os documentos em PDF nesta conversa, em seguida.",
      closing: "Qualquer dúvida, estou à disposição.",
    },
    email: {
      title: "Enviar por e-mail",
      composeStep: "Destinatários e anexos",
      reviewStep: "Revisão e envio",
      loading: "Carregando hospitais, empresas e reservas…",
      loadError: "Não foi possível carregar as informações. Feche e tente novamente.",
      connectIntro: "Conecte sua conta Google para enviar os documentos do seu próprio e-mail aos hospitais e empresas vinculados.",
      connectPermission: "Na tela do Google, marque a permissão \"Enviar e-mail em seu nome\". Sem ela, o envio não funciona.",
      connect: "Conectar conta Google",
      connecting: "Redirecionando…",
      notNow: "Agora não",
      notConnected: "Conecte sua conta de email para enviar documentos.",
      sendFailed: "Não foi possível enviar o email. Tente reconectar sua conta Google.",
      hospitals: "Hospitais",
      companies: "Empresas de OPME",
      reservas: "Reservas",
      optional: "Opcional",
      noRecipient: "Selecione ao menos um hospital ou uma empresa.",
      noHospitals: "Você ainda não tem nenhum hospital vinculado ao seu perfil. Vincule um abaixo para poder enviar os documentos.",
      noCompanies: "Você ainda não tem nenhuma empresa de OPME vinculada ao seu perfil. Vincule uma abaixo, informando o e-mail, para poder enviar os documentos.",
      noReservas: "Você ainda não tem nenhuma reserva vinculada ao seu perfil. Vincule uma abaixo, se desejar incluí-la no envio.",
      linkHospital: "Vincular outro hospital",
      linkCompany: "Vincular outra empresa",
      linkReserva: "Vincular outra reserva",
      linkAndSelect: "Vincular e selecionar",
      addCompanyEmail: "Adicionar e-mail para selecionar",
      withoutEmail: "{{name}} sem e-mail",
      pdfs: "PDFs para enviar",
      dropTitle: "Selecione ou arraste os PDFs",
      dropMore: "Adicionar mais PDFs",
      dropHint: "Somente PDF, até 10 MB por arquivo",
      noFiles: "Anexe ao menos um PDF.",
      notPdf: { one: "Um arquivo foi ignorado por não ser PDF.", other: "{{count}} arquivos foram ignorados por não serem PDF." },
      tooBig: "{{name}} tem mais de 10 MB. Reduza o arquivo e tente novamente.",
      removeFile: "Remover {{name}}",
      subject: "Assunto",
      subjectRequired: "Informe o assunto.",
      reservasAutoHint: "As reservas selecionadas são incluídas automaticamente no texto.",
      noReservaTitle: "Enviar sem reservas?",
      noReservaMessage: "Nenhuma reserva foi selecionada. Se o procedimento precisar de UTI, hemoderivados ou equipamentos, selecione as reservas antes de continuar.",
      noReservaBack: "Voltar e selecionar",
      noReservaContinue: "Continuar sem reservas",
      reviewIntro: "Confira antes de enviar. Os PDFs serão enviados imediatamente a partir da sua conta Google.",
      attachments: "Anexos ({{count}})",
      group: "{{title}} ({{count}})",
      send: "Confirmar e enviar",
      sentTo: "Enviado para: {{to}}",
      defaultSubject: "Documentos do pedido cirúrgico",
      defaultSubjectWithPatient: "Documentos do pedido cirúrgico – {{patient}}",
      bodyGreeting: "Prezado(a),",
      bodyAttached: "Segue em anexo os documentos referentes ao pedido cirúrgico.",
      bodyAttachedWithPatient: "Segue em anexo os documentos referentes ao pedido cirúrgico do paciente {{patient}}.",
      bodyReservas: "Solicito também as seguintes reservas:",
      bodyClosing: "Qualquer dúvida, estou à disposição.",
      bodySignature: "Atenciosamente,",
    },
  },
  appeals: {
    title: "Recursos",
    progress: "Passo {{step}} de {{total}} · ",
    next: "Próximo: {{label}}",
    steps: {
      order: "Selecionar pedido",
      items: "Itens recusados",
      grounds: "Fundamentos",
      confirm: "Confirmação",
      generated: "Recurso gerado",
      review: "Validação técnica",
      done: "Finalizado",
    },
    cta: {
      continue: "Continuar",
      generate: "Gerar recurso",
      generating: "Gerando…",
      finish: "Finalizar",
    },
    blocked: {
      order: "Selecione um pedido para continuar.",
      items: "Selecione ao menos 1 item recusado para continuar.",
      grounds: "Selecione ao menos 1 fundamento para continuar.",
      refs: "Inclua ao menos 1 referência para continuar.",
      links: "Abra o link de todas as referências incluídas para continuar.",
      declaration: "Aceite a declaração de responsabilidade para continuar.",
    },
    order: {
      intro: "Primeiro escolha o paciente. Em seguida selecione o pedido que será recorrido.",
      patient: "Paciente",
      choosePatient: "Escolha o paciente",
      loadingPatients: "Carregando pacientes…",
      noPatients: "Nenhum paciente encontrado.",
      loadingOrders: "Carregando pedidos…",
      noOrders: "Nenhum pedido encontrado para este paciente.",
      orderTitle: "#{{code}} · {{procedure}}",
    },
    items: {
      intro: "Marque os códigos e materiais negados que farão parte do recurso.",
      denial: "Negativa da operadora",
      denialHint: "Cole a justificativa enviada pela operadora ou anexe o documento da negativa. É opcional.",
      denialSource: "Forma de informar a negativa",
      text: "Texto",
      file: "Arquivo",
      textLabel: "Texto da negativa",
      textPlaceholder: "Cole aqui o texto da negativa (e-mail ou justificativa da operadora)…",
      fileTitle: "Selecione o arquivo da negativa",
      fileHint: "PDF, JPG ou PNG",
      fileChange: "Trocar",
      fileRemove: "Remover",
      codes: "Códigos solicitados",
      materials: "Materiais solicitados",
      empty: "Nenhum item neste pedido.",
    },
    grounds: {
      intro: "Escolha os fundamentos que sustentam o recurso. A IA processará apenas o que você marcar.",
      tip: "Dica: inclua as referências bibliográficas em toda contestação.",
      bibliografia: {
        title: "Busca de Referências Bibliográficas Técnicas",
        description: "Busca em bases de dados médicas por artigos, diretrizes e consensos que suportam a indicação.",
      },
      cdc: {
        title: "Fundamentação CDC (Código de Defesa do Consumidor)",
        description: "Argumentação com base nos direitos do consumidor e continuidade do cuidado.",
      },
      lgpd: {
        title: "Fundamentação LGPD (Lei Geral de Proteção de Dados)",
        description: "Avalia possível compartilhamento indevido de dados do paciente ou auditoria sem consentimento.",
      },
      atoMedico: {
        title: "Fundamentação Ato Médico",
        description: "Reforça a autonomia do médico e delimita os limites da auditoria.",
      },
      resolucao: {
        title: "Resolução 2.448/2025 (CFM)",
        description: "Proíbe negativas de cobertura sem contato direto com o paciente (presencial ou remoto, com consentimento), exigindo avaliação clínica efetiva pelo médico auditor em conjunto com o médico assistente — decisões baseadas exclusivamente em documentação são vedadas.",
      },
    },
    confirm: {
      intro: "Confira as informações antes de gerar o recurso. Você poderá editar o texto depois.",
      order: "Pedido",
      patient: "Paciente",
      procedure: "Procedimento",
      date: "Data",
      items: "Itens recusados",
      grounds: "Fundamentos",
      notice: "O conteúdo será elaborado apenas com base nas opções marcadas.",
      generatingTitle: "Gerando o recurso…",
      generatingHint: "Isso pode levar alguns segundos. Não feche esta aba.",
    },
    generated: {
      intro: "Revise e ajuste o texto, se necessário.",
      heading: "Recurso administrativo",
      denial: "Identificação e negativa",
      cdc: "Fundamentação CDC",
      atoMedico: "Fundamentação Ato Médico",
      lgpd: "Fundamentação LGPD",
      resolucao: "Resolução 2.448/2025 (CFM)",
      references: "Fundamentação técnica",
      referencesHint: "Recarregue cada seção para buscar novas referências sem afetar a outra.",
      procedures: "Procedimentos",
      opme: "Materiais / OPME",
      refCount: { zero: "Nenhuma referência", one: "1 referência", other: "{{count}} referências" },
      noRefs: "Nenhuma referência encontrada.",
      reload: "Recarregar",
      reloading: "Buscando",
    },
    review: {
      intro: "Remova as referências que não forem pertinentes e abra o link de cada uma incluída para conferir.",
      noRefsTitle: "Sem referências bibliográficas",
      noRefsBody: "Nenhuma busca de referências foi solicitada. O recurso será fundamentado com os argumentos selecionados.",
      declaration: "Declaro que revisei os fundamentos e, quando aplicável, as referências bibliográficas listadas, e assumo a responsabilidade técnica pelo recurso gerado.",
    },
    done: {
      title: "Recurso finalizado",
      body: "O recurso foi gerado, validado e associado ao pedido {{procedure}}.",
      protocol: "Protocolo",
      generatedAt: "Gerado em",
      validatedAt: "Validação técnica",
      references: "Referências",
      disclaimer: "As referências técnicas deste recurso foram analisadas e validadas pelo médico assistente, que assume integral responsabilidade pela indicação clínica e pelos fundamentos técnicos apresentados.",
      download: "Baixar PDF",
      share: "Enviar",
      email: "Enviar por e-mail",
      emailHint: "Hospitais e empresas vinculados",
      whatsApp: "Enviar pelo WhatsApp",
      whatsAppHint: "Abre a conversa com mensagem pronta",
      restart: "Iniciar novo recurso",
    },
  },
  onboarding: {
    title: "Insira alguns dados adicionais",
    name: "Nome completo",
    crm: "CRM",
    specialty: "Especialidade médica",
    specialtyPlaceholder: "Selecione",
    submit: "Confirmar",
    hintDoctor: "Preencha nome, CRM e especialidade",
    hintSecretary: "Preencha seu nome",
  },
  billing: {
    noOpenInvoice: "Nenhuma fatura em aberto encontrada. Fale com a LetsDoc.",
    // Faixa de aviso de cobrança no topo das telas autenticadas.
    notice: {
      dismiss: "Fechar aviso",
      amount: " de {{value}}",
      cta: {
        opening: "Abrindo...",
        pay: "Pagar fatura",
        updateCard: "Atualizar cartão",
        reactivate: "Reativar",
        subscribe: "Assinar",
        talkToUs: "Falar com a LetsDoc",
      },
      usage: { surgery: "Pacotes de cirurgia", opme: "Pacotes de OPME", item: "{{label}}: {{used}}/{{max}}" },
      payer: {
        overdue: "A fatura{{amount}} venceu em {{since}}. Pague até {{suspends}} para o acesso não ser suspenso.",
        overdueNoData: "A fatura venceu. Pague para o acesso não ser suspenso.",
        cardFailed: "Não conseguimos cobrar o cartão{{amount}}. Atualize até {{suspends}} para o acesso não ser suspenso.",
        cardFailedNoData: "Não conseguimos cobrar sua assinatura. Atualize o cartão para evitar a suspensão do acesso.",
        suspended: "Acesso suspenso por falta de pagamento{{amount}}. Pague para liberar na hora — o plano será encerrado em {{cancels}}.",
        suspendedNoData: "Acesso suspenso por falta de pagamento. Pague para liberar na hora.",
        closedDebt: "Seu plano foi encerrado por falta de pagamento e há valores em débito. Fale com a LetsDoc para regularizar.",
        cancelsOn: "Sua assinatura termina em {{date}}.",
        cancelsNoDate: "Sua assinatura está marcada para cancelar.",
        trialEndsOn: "Você está no período de teste. A primeira cobrança será em {{date}} — cancele antes disso se não quiser continuar.",
        trialNoDate: "Você está no período de teste.",
        trialPaymentPending: "Seu período de teste terminou, mas a primeira cobrança{{amount}} não foi aprovada. Você está no plano Básico até o pagamento — pague até {{cancels}} para manter o plano.",
        trialPaymentPendingNoData: "Seu período de teste terminou, mas a primeira cobrança não foi aprovada. Pague para voltar ao seu plano.",
        trialEnded: "Seu período de teste terminou e você está no plano Básico. Assine para voltar ao Premium ou Profissional.",
        expired: "Você voltou ao plano Gratuito. Assine de novo para voltar ao Premium ou Profissional.",
        grantEndsOn: "Seu acesso liberado termina em {{date}}. Assine para continuar sem interrupção.",
        grantEndsNoDate: "Seu acesso liberado está terminando. Assine para continuar sem interrupção.",
        grantEnded: "Seu acesso liberado terminou e você voltou ao plano Gratuito. Assine para voltar ao Premium ou Profissional.",
      },
      owner: {
        trialEndsOn: "O acesso experimental da clínica termina em {{date}}. Para contratar, fale com a LetsDoc.",
        trialEndsNoDate: "O acesso experimental da clínica está terminando. Para contratar, fale com a LetsDoc.",
        trialEnded: "O acesso experimental da clínica terminou e todos voltaram ao Básico. Para contratar, fale com a LetsDoc.",
        cancelsOn: "O plano da clínica termina em {{date}}. Para renovar, fale com a LetsDoc.",
        cancelsNoDate: "O plano da clínica está marcado para terminar. Para renovar, fale com a LetsDoc.",
        closedDebt: "O plano da clínica foi encerrado por falta de pagamento e há valores em débito. Fale com a LetsDoc para regularizar.",
        expired: "O plano da clínica foi encerrado e não há valores em aberto. Para reativar, fale com a LetsDoc.",
      },
      member: {
        pending: "A assinatura da clínica tem um pagamento pendente. Fale com o responsável — o acesso será suspenso em {{date}}.",
        suspended: "O acesso da clínica está suspenso por uma pendência de pagamento. Fale com o responsável pela clínica.",
        closedDebt: "O plano da clínica foi encerrado por falta de pagamento. Fale com o responsável pela clínica.",
        ended: "O plano da clínica terminou. Fale com o responsável pela clínica.",
      },
    },
    plans: {
      title: "Escolha seu plano",
      annualOff: "{{percent}}% off",
      trialNotice:
        "Teste grátis por {{days}} dias. Você cadastra o cartão agora e a primeira cobrança só acontece no fim do teste. Se cancelar antes, nada é cobrado.",
      trialActive:
        "Você está no período de teste do {{plan}} até {{date}}. Trocar de plano agora não gera cobrança: a primeira cobrança já sai no plano escolhido.",
      currentNotice:
        "Seu plano atual é o {{plan}}. Subir de plano vale na hora (você paga só a diferença proporcional); trocar para um plano menor vale a partir da próxima renovação.",
      clinicOwner: "O plano da sua clínica é negociado diretamente com a LetsDoc. Para contratar ou mudar o plano,",
      clinicOwnerLink: "fale com a LetsDoc",
      clinicMember:
        "Sua conta está vinculada a uma clínica, e o plano é gerenciado pelo responsável por ela. Para ter um plano individual, crie uma conta com outro e-mail.",
      ownerOnly: "Apenas o responsável pela cobrança da clínica pode assinar. Peça para ele escolher o plano.",
      loadError: "Não foi possível carregar os preços. Tente de novo em instantes.",
      perMonth: "{{price}}/mês",
      billedYearly: "Cobrado {{price}} por ano",
      loading: "Carregando...",
      unavailable: "Preço indisponível",
      mostChosen: "Mais escolhido",
      currentBadge: "Plano atual",
      annualTerms:
        "No anual, a cobrança é feita uma vez por ano. Você pode desistir com reembolso integral em até 7 dias após a cobrança; depois disso, o cancelamento vale no fim do período, sem reembolso proporcional.",
      button: {
        trial: "Testar {{days}} dias grátis",
        subscribe: "Assinar",
        keep: "Manter este plano",
        current: "Plano atual",
        scheduled: "Troca agendada",
        switch: "Trocar para este plano",
      },
      done: {
        scheduled: "Troca agendada para {{date}}.",
        scheduledPeriodEnd: "Troca agendada para o fim do período.",
        cancelled: "Troca cancelada. Você continua no plano atual.",
        changed: "Plano alterado.",
      },
      confirm: {
        keepTitle: "Manter o plano atual?",
        switchTitle: "Trocar para {{plan}}?",
        keep: "A troca agendada é cancelada e você continua no {{plan}}.",
        trial: "A troca vale agora, sem cobrança. A primeira cobrança, em {{date}}, já será no {{plan}}.",
        upgrade: "A troca vale agora. Hoje você paga só a diferença proporcional ao tempo que falta no período atual.",
        downgradeOn: "A troca vale em {{date}}. Até lá você continua no {{plan}}, sem cobrança extra.",
        downgradeRenewal: "A troca vale na próxima renovação. Até lá você continua no {{plan}}, sem cobrança extra.",
        undoCancel: "Seu cancelamento agendado será desfeito e a assinatura continua.",
        submit: "Confirmar",
      },
    },
    checkout: {
      forbidden: "Apenas o responsável pela cobrança da sua clínica pode assinar um plano. Peça para ele acessar este link.",
      invalidPlan: "Este plano não está mais disponível. Redirecionando...",
      error: "Não foi possível iniciar a assinatura agora. Tente novamente em instantes.",
    },
    confirming: {
      missingSession: "Link de confirmação inválido — nenhuma sessão de pagamento foi informada.",
      timeoutTitle: "Ainda confirmando...",
      timeoutBody:
        "Ainda estamos confirmando seu pagamento — isso pode levar alguns minutos. Você pode fechar esta página; avisaremos por e-mail assim que confirmarmos.",
    },
    invite: {
      goToApp: "Ir para o app",
      continue: "Continuar",
      notNow: "Agora não",
      recipient: "Destinatário",
      validUntil: "Válido até",
      loadError: "Não foi possível carregar este convite agora. Tente novamente em instantes.",
      processError: "Não foi possível processar o convite agora. Tente novamente em instantes.",
      emailMismatch: "Este convite foi enviado para outro e-mail{{masked}}. Entre com a conta correta.",
      cancelTitle: "Seu plano individual será cancelado",
    },
    paymentInvite: {
      invalid: "Este convite expirou ou não está mais disponível. Fale com quem enviou.",
      title: "Você recebeu um convite",
      discount: "Com desconto especial",
      price: "Valor negociado",
      doctors: "Médicos inclusos",
      payment: "Pagamento",
      invoice: "Fatura (boleto ou cartão)",
      card: "Cartão",
      dueDate: "Vencimento",
      dueDaysOne: "{{count}} dia após a emissão",
      dueDaysOther: "{{count}} dias após a emissão",
      accessTitle: "Acesso liberado",
      accessBody:
        "O plano da clínica já está ativo. A fatura também foi enviada para o e-mail de cobrança e pode ser paga por boleto ou cartão{{deadline}}. Boletos levam alguns dias úteis para compensar.",
      deadlineOne: " em até {{count}} dia",
      deadlineOther: " em até {{count}} dias",
      deadlineDue: " até o vencimento",
      openInvoice: "Abrir fatura",
      cancelNext: "Em seguida você segue para o pagamento do plano da clínica.",
      cancelConfirm: "Cancelar meu plano e continuar",
      alreadyTitle: "Você já tem uma assinatura ativa",
      alreadyBody: "Sua assinatura já está em vigor. Entre no app para continuar.",
      manage: "Gerenciar assinatura",
      forbidden: "Apenas o responsável pela cobrança da sua clínica pode aceitar este convite. Peça para ele acessar este link.",
    },
    accessInvite: {
      invalid:
        "Este convite já foi usado, expirou ou não está mais disponível. Se você já entrou na clínica, acesse o app normalmente; senão, peça um novo link a quem enviou.",
      title: "Você foi convidado",
      clinic: "clínica",
      clinicFallback: "Clínica",
      noCost: "Sem custo para você",
      body: "O acesso é pago pela clínica — você só precisa criar seu cadastro.",
      confirmTitle: "Entrar na {{clinic}}?",
      confirmBody: "Seu cadastro passa a usar o plano da clínica. Seus pacientes e documentos continuam seus.",
      enter: "Entrar na clínica",
      cancelNext: "Depois de entrar, você usa o plano da {{clinic}}.",
      cancelConfirm: "Cancelar meu plano e entrar",
    },
  },
  session: {
    loadFailedTitle: "Não foi possível carregar sua conta",
    loadFailedBody: "Verifique sua conexão e tente de novo em alguns instantes.",
  },
  offline: {
    banner: "Você está sem internet. Pode continuar editando; tente salvar quando a conexão voltar.",
  },
};
